import React from 'react';
import { FORM_STEPS, isFirstStep } from '../../constants/formSteps';
import { useAddCaseFormContext } from '../../contexts/AddCaseFormContext';
import XButton from '../common/XButton';

const getDefaultName = (tabType, index) => {
    return tabType === "client" ? `Plaintiff ${index}` : `Defendant ${index}`
}

const firstStepClasses = "bg-white h-[calc(var(--spacing)*6.5)] p-1.5";
const multiStepClasses = "px-4 py-0 rounded";

const tabBaseClasses = "px-6! py-2! mr-2 rounded-t-md! rounded-b-none text-sm z-[99999]";

// Only the selected tab carries a tint; inactive tabs sit on Stone. They used to
// share the mint, which left the strip uniformly teal with no active tab visible.
const tabActiveClasses = "font-bold text-content bg-white!";
const tabActiveModalClasses = "font-bold text-content bg-primary-surface!";
const tabInactiveClasses = "text-subtle bg-surface-alt!";

const getTabStateClasses = ({ isActive, isModalTab }) => {
    if (!isActive) return tabInactiveClasses;
    return isModalTab ? tabActiveModalClasses : tabActiveClasses;
}

const Tabs = ({ tabList = [], selectedTabIndex = 0, onTabChange, addNewTab = null, tabType, formSteps, isModalTab = false }) => {
    const { addCaseFormStep } = useAddCaseFormContext();
    const currentFormStep = formSteps ?? addCaseFormStep ?? FORM_STEPS.CASE_INFO;
    return (
        <>
            <div className={`flex items-center flex-wrap ${isFirstStep(currentFormStep) ? firstStepClasses : multiStepClasses}`}>
                {tabList.map((elem, index) => {
                    const isActive = index === selectedTabIndex;
                    return (
                        <XButton
                            key={index}
                            variant="close"
                            className={`${tabBaseClasses} ${getTabStateClasses({ isActive, isModalTab })}`}
                            onClick={() => onTabChange(index)}
                            aria-pressed={isActive}
                        >
                            {elem?.name ? elem.name : getDefaultName(tabType, index)}
                        </XButton>
                    );
                })}

                {addNewTab && (
                    <XButton
                        variant="link"
                        className="ml-2 text-primary! font-medium text-sm! no-underline"
                        onClick={addNewTab}
                    >
                        + Add Plaintiff
                    </XButton>
                )}
            </div>
        </>
    )
}

export default Tabs;